(function () {
  const script = document.currentScript;
  const prefillTemplate = script && script.dataset.enquiryTemplate;
  const allowedModels = new Set(['HKD2K', 'HKM2W', 'HRS5E', 'HRF2E', 'HRF5E', 'HFM18D', 'HFN236L', 'HFM18A', 'HFD173L', 'HFC198L', 'HMR20M2', 'HMR20EB', 'HMR20EG2', 'HMR20MB', 'HMR20E', 'HMR20EG3B', 'HMR20EG3', 'HMR20EG', 'HMR20MW', 'HMR20E2']);
  const model = new URL(window.location.href).searchParams.get('model');
  if (!allowedModels.has(model) || !prefillTemplate) return;
  function prefill() {
    document.querySelectorAll('form[action*="/contact"] textarea[name="contact[body]"]').forEach(function (field) {
      if (field.value.trim() || field.dataset.hanmacModelPrefilled) return;
      field.value = prefillTemplate.replaceAll('__HANMAC_MODEL__', model);
      field.dataset.hanmacModelPrefilled = model;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill, { once: true });
  else prefill();
  document.addEventListener('shopify:section:load', prefill);
})();
